// extracted by mini-css-extract-plugin
export default {"menuBlock":"dE-z","title":"eE-z","nav":"fE-z","flexCell":"gE-z","facetLink":"hE-z"};